module.exports = __webpack_public_path__ + "assets/img/teacher (27).2f65a845.png";